import React from 'react';
import './GuaranteeItem.css';

/**
 * GuaranteeItem Component
 * Individual guarantee item with icon and ripple effect
 * 
 * @param {string} text - Guarantee text
 * @param {string} icon - Icon character (default: '✓')
 * @param {string} className - Additional CSS classes
 */
const GuaranteeItem = ({ text, icon = '✓', className = '' }) => {
  return (
    <div className={`guarantee-item ${className}`}>
      <div className="guarantee-icon-container">
        <span className="guarantee-icon">{icon}</span>
        <div className="icon-ripple"></div>
      </div>
      <span className="guarantee-text">{text}</span>
    </div>
  );
};

export default GuaranteeItem;


